import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import LoadingComponent from "@/pcomponents/common/content/loading";

function DelSelectTodoPopup(props: any) {
  let myProps = {
    todo_pri_val_arr: [],
    list_opt: {},
    refreshData: () => { },
    closePopup: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const listAggridRef = useRef<any>();
  const xColumnArr = getXcolumnJson();
  const [filter_opt, set_filter_opt] = useState<any>({
    subject: "",
    sort: "",
  });
  const [infoArr, setInfoArr] = useState([]);
  let select_subject_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  let todo_sort_option_arr = [
    { "value": "study", "text": "수업" },
    { "value": "homework", "text": "숙제" },
  ];
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  useEffect(() => {
    get_todo_arr_by_ajax({});
  }, []);

  const get_todo_arr_by_ajax = (inData: any) => {
    let form_json_data = {
      "s_pri_arr": myProps.todo_pri_val_arr,
      "s_stu_mcomp_seq": user.mcomp_seq,
      order_id: "a_reserve_start_date ,a_subject_name, a_ymd, a_seq",
      is_paging: "",
      ...myProps.list_opt,
      ...inData
    };

    if (strFunc.is_empty(form_json_data.s_pri_arr)) {
      alert("키정보가 없습니다.");
      return;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_filter_info_arr = (inData: any) => {
    let opt_obj = {
      subject: filter_opt.subject,
      sort: filter_opt.sort,
      ...inData
    };

    let tmp_info_arr: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      let is_add = true;
      if (!strFunc.is_empty(opt_obj.subject)) {
        if (infoArr[i]["a_subject"] != opt_obj.subject) {
          is_add = false;
        }
      }
      if (!strFunc.is_empty(opt_obj.sort)) {
        if (infoArr[i]["a_sort"] != opt_obj.sort) {
          is_add = false;
        }
      }
      if (is_add) {
        tmp_info_arr.push(infoArr[i]);
      }
    }
    return tmp_info_arr;
  };

  const set_list_by_filter = (inData: any) => {
    let opt_obj = {
      subject: filter_opt.subject,
      sort: filter_opt.sort,
      ...inData
    };
    let tmp_info_arr = get_filter_info_arr(opt_obj);
    listAggridRef.current.setInfoArr(tmp_info_arr);
  };

  const delete_todo_by_ajax = (inData: any) => {
    let opt_obj={
      is_del_all:false,
      ...inData
    };
    let del_todo_info_arr = get_filter_info_arr({});
    if(opt_obj.is_del_all==false){
      del_todo_info_arr = listAggridRef.current.getSelectedRows();
    }
    if (del_todo_info_arr.length == 0) {
      let del_leng_alert_msg="삭제할 맞춤플랜이 없습니다.";
      if(opt_obj.is_del_all==false){
        del_leng_alert_msg="선택된 맞춤플랜이 없습니다.";
      }
      alert(del_leng_alert_msg);
      return;
    }

    if (confirm(del_todo_info_arr.length + "개의 맞춤플랜을 삭제하시겠습니까?") == false) {
      return;
    }

    let del_row_arr: any = [];
    for (let i = 0; i < del_todo_info_arr.length; i++) {
      let row_info = del_todo_info_arr[i];
      del_row_arr.push({
        a_ymd: row_info.a_ymd,
        a_seq: row_info.a_seq,
        a_stu_name: row_info.a_stu_name
      });
    }

    let form_json_data = {
      "data_arr": del_row_arr,
    };
    set_loading_data({
      is_display: true,
      text: "로딩중.",
    });
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: false,
            text: "로딩중.",
          });
          alert("선택한 맞춤플랜을 모두 삭제하였습니다.");
          myProps.refreshData();
          myProps.closePopup();
        } else {
          alert("맞춤플랜 삭제에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  const cellClickedListener = (params: any) => {
    var key = params.colDef.field;

  };

  const cellRenderer = (params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;
    if (key == "row_view_success_sort") {
      let sort_str = params.data.a_success_sort;
      if (xColumnArr.select_arr["a_success_sort"]) {
        for (let i = 0; i < xColumnArr.select_arr["a_success_sort"].length; i++) {
          let tmp_option_row = xColumnArr.select_arr["a_success_sort"][i];
          if (tmp_option_row["value"] == sort_str) {
            sort_str = tmp_option_row["text"];
          }
        }
      }
      render_str = (
        <div>
          {sort_str}
        </div>
      );
    } else if (key == "row_view_state") {
      let state_str = params.data.a_state;
      if (xColumnArr.select_arr["a_state"]) {
        for (let i = 0; i < xColumnArr.select_arr["a_state"].length; i++) {
          let tmp_option_row = xColumnArr.select_arr["a_state"][i];
          if (tmp_option_row["value"] == state_str) {
            state_str = tmp_option_row["text"];
          }
        }
      }
      render_str = (
        <div>
          {state_str}
        </div>
      );
    } else if (key == "row_view_per") {
      let per_str = TodoStateFunc.get_percent_by_todo_info(params.data);
      if (params.data.a_is_success == "1") {
        per_str = 100;
      }
      let per_color_json = TodoStateFunc.get_color_of_percent(per_str);
      let per_div_style: any = {};
      per_div_style["color"] = per_color_json.per;
      render_str = (
        <div style={per_div_style}>
          {per_str} %
        </div>
      );
    } else if (key == "row_view_success_amount") {
      if (params.data.a_success_sort == "amount") {
        render_str = params.data.a_amount_num + "/" + params.data.a_success_amount;
      }
    } else if (key == "row_view_time_str") {
      let tmp_time_json: any = strFunc.secondsToTimeJson(params.data.a_time_sec);
      render_str = tmp_time_json.i + ":" + tmp_time_json.s;
      if (tmp_time_json.h != "00") {
        render_str = tmp_time_json.h + ":" + render_str;
      }
    } else if (key == "row_view_reserve_date") {
      render_str = params.data["a_reserve_start_date"].substring(5, 10);
    } else if (key == "row_view_par_title") {
      if (params.data.study_info) {
        if (params.data.study_info.title_info) {
          render_str = params.data.study_info.title_info.a_title;
        }
      }
      if (params.data.video_info) {
        if (params.data.video_info.corse_info) {
          render_str = params.data.video_info.corse_info.a_title;
        }
      }
    } else if (key == "row_view_par_section") {
      if (params.data.study_info) {
        if (params.data.study_info.section_info) {
          render_str = params.data.study_info.section_info.a_title;
        }
      }
      if (params.data.video_info) {
        if (params.data.video_info.section_info) {
          render_str = params.data.video_info.section_info.a_title;
        }
      }
    }
    return render_str;
  };

  let filtered_info_arr = get_filter_info_arr({});

  return (
    <div>
      <ListAggrid
        ref={listAggridRef}
        infoArr={filtered_info_arr}
        xColumnArr={{ ...xColumnArr }}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: false,
          is_add_checkbox: true,
          floatingFilter: false,
          rowMultiSelectWithClick: true,
          onGridReady: () => {

          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer
        }}
      ></ListAggrid>
      <div className='my_flex_center mt-1'>
        <span>과목:</span>
        <select className='search-input' value={filter_opt.subject} name={"subject"}
          onChange={(e: any) => {
            let tmp_filter_opt = { ...filter_opt };
            tmp_filter_opt.subject = e.target.value;
            set_filter_opt(tmp_filter_opt);
            set_list_by_filter({ subject: e.target.value });
          }}>
          <option value=''>전체</option>
          {select_subject_option_arr.map((option_row: any, index: number) => (
            <option key={index} value={option_row.value}>{option_row.text}</option>
          ))}
        </select>
        구분:
        <select className='search-input' value={filter_opt.sort} name={"sort"}
          onChange={(e: any) => {
            let tmp_filter_opt = { ...filter_opt };
            tmp_filter_opt.sort = e.target.value;
            set_filter_opt(tmp_filter_opt);
            set_list_by_filter({ sort: e.target.value });
          }}>
          <option value=''>전체</option>
          {todo_sort_option_arr.map((option_row: any, index: number) => (
            <option key={index} value={option_row.value}>{option_row.text}</option>
          ))}
        </select>
      </div>
      <div className='my_flex_center mt-1'>
        <span>총 <span style={{ color: "blue" }}>{filtered_info_arr.length}</span>개 맞춤플랜</span>
      </div>
      <div className='my_flex_center mt-1'>
        <button className='btn-l btn-red'
          onClick={() => {
            delete_todo_by_ajax({ is_del_all: false });
          }}
        >선택삭제</button>
        {/* <button className='btn-l btn-red'
          onClick={() => {
            delete_todo_by_ajax({ is_del_all: true });
          }}
        >모두삭제</button> */}
        <button className='btn-l btn-dark'
          onClick={() => {
            myProps.closePopup();
          }}
        >닫기</button>
      </div>
      {loading_data.is_display &&
        <LoadingComponent text={loading_data.text}></LoadingComponent>
      }
    </div>
  );
};
export default DelSelectTodoPopup;